/* Casca Rija: legal links for popup Shopify Forms 1221523. */
(() => {
  'use strict';
  const formId = '1221523';
  const styleId = 'cr-popup-legal-links';
  const labels = [
    ['Política de Privacidade', 'privacy-policy'], ['Termos de serviço', 'terms-of-service'],
    ['Privacy Policy', 'privacy-policy'], ['Terms of Service', 'terms-of-service'],
    ['Datenschutzerklärung', 'privacy-policy'], ['Datenschutzbestimmungen', 'privacy-policy'], ['Nutzungsbedingungen', 'terms-of-service'],
    ['Política de privacidad', 'privacy-policy'], ['Términos del servicio', 'terms-of-service'], ['Términos de servicio', 'terms-of-service'],
    ['Politique de confidentialité', 'privacy-policy'], ["Conditions d'utilisation", 'terms-of-service'], ['Conditions d’utilisation', 'terms-of-service'],
    ['Informativa sulla privacy', 'privacy-policy'], ['Termini di servizio', 'terms-of-service'],
    ['privacybeleid', 'privacy-policy'], ['algemene voorwaarden', 'terms-of-service'], ['gebruiksvoorwaarden', 'terms-of-service'], ['Servicevoorwaarden', 'terms-of-service'],
    ['Polityce Prywatności', 'privacy-policy'], ['Warunkach korzystania z usługi', 'terms-of-service'],
    ['integritetspolicy', 'privacy-policy'], ['användarvillkor', 'terms-of-service']
  ];
  const rootPath = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  function linkText(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement.closest('a,script,style')) nodes.push(node);
    }
    nodes.forEach(node => {
      const text = node.nodeValue || '';
      const lower = text.toLocaleLowerCase();
      const matches = [];
      labels.forEach(([label, path]) => {
        const index = lower.indexOf(label.toLocaleLowerCase());
        if (index >= 0) matches.push({ index, end: index + label.length, path });
      });
      matches.sort((a,b) => a.index-b.index || b.end-a.end);
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let cursor = 0;
      matches.forEach(match => {
        if (match.index < cursor) return;
        fragment.appendChild(document.createTextNode(text.slice(cursor,match.index)));
        const a = document.createElement('a');
        a.textContent = text.slice(match.index,match.end);
        a.href = rootPath + 'policies/' + match.path;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.dataset.crPolicyLink = match.path;
        fragment.appendChild(a);
        cursor = match.end;
      });
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
      node.replaceWith(fragment);
    });
  }
  function polish(host) {
    const shadow = host.shadowRoot;
    if (!shadow) return;
    const legal = shadow.querySelector('form[data-testid="form"] + div');
    if (!legal) return;
    linkText(legal);
    if (!shadow.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = 'form[data-testid="form"] + div a[data-cr-policy-link] { color: #234c38 !important; text-decoration: underline !important; text-underline-offset: 2px; font-weight: 700; } form[data-testid="form"] + div a[data-cr-policy-link]:focus-visible { outline: 2px solid #234c38; outline-offset: 3px; }';
      shadow.appendChild(style);
    }
    if (!host.dataset.crLegalEventsReady) {
      host.dataset.crLegalEventsReady = 'true';
      const refresh = () => window.setTimeout(() => polish(host), 100);
      host.addEventListener('change', refresh);
      host.addEventListener('input', refresh);
      host.addEventListener('click', refresh);
    }
  }
  let attempts = 0;
  function apply() {
    const host = document.getElementById('app-embed-container-' + formId);
    if (host && host.tagName.toLowerCase() === 'shopify-forms-embed') polish(host);
    attempts += 1;
    if (attempts < 180) window.setTimeout(apply,1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',apply,{once:true});
  else apply();
})();
